import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalProps, Spin  } from "antd";
import Draggable from "react-draggable";
import { generateClassName } from "jzfz-web-utils";
import CustomEmpty from "../../component/customEmpty/CustomEmpty";
import { ModuleEnum } from "../../config/constant";
import Section from '../../component/tinymceEditor/Section';
import { NumberSize, Resizable } from "re-resizable";
import './style/connectKnowledgeModal.less';
import { treeUtil } from "jzfz-web-utils";
import { Direction } from "re-resizable/lib/resizer";
import '../expandButton/style/expandButton.less';
import KnowledgeGroup, {KnowledgeGroupData} from "./KnowledgeGroup";

const { getListFromTree } = treeUtil;


interface NodeInfo {
	type: ModuleEnum;	// 知识类型
	pkid: string;	// 知识pkid
}


export interface ConnectKnowledgeModalProps extends ModalProps {
	data?: KnowledgeGroupData;	// 数据源
	loading?: boolean;
	onSelect?: (data: NodeInfo) => void;	// data 选中的知识的信息
}


/**
 * 关联知识内容展示弹窗
 * @param props
 * @constructor
 */
const ConnectKnowledgeModal = (props: ConnectKnowledgeModalProps) => {
	const { width = 1200, data: dataSource, loading, visible, onSelect = (data: NodeInfo) => { }, className, ...restProps } = props;
	const [info, setInfo] = useState<{ type?: any, pkid?: string, figureNumber?: string }>(null);	// type: 知识类型 pkid: 知识pkid
	const [selectedKeys, setSelectedKeys] = useState<string[]>([]);	// 选中的知识pkid
	const [modalWidth, setModalWidth] = useState<number | string>(width);	// 知识弹窗的宽度
	const resizeDelta = useRef<NumberSize>({ width: 0, height: 0 }); // 知识弹窗的宽度拖拽后的宽度


	useEffect(() => {
		return () => {
			setSelectedKeys([]);
			setInfo(null);
		}
	}, [visible])


	useEffect(() => {
		setModalWidth(width);
	}, [dataSource])


	/**
	 * 自动选中第一个可选节点
	 * @param treeData
	 */
	const autoSelectFirstNode = (treeData: any[]) => {
		let target = getListFromTree(treeData).find((v: any) => v.selectable);
		if (target) {
			select(target);
		}
	}


	/**
	 * 选择节点
	 * @param data
	 */
	const select = (data: any) => {
		const { moduleType, pkid, selectable, figureNumber } = data;
		if (!selectable) {
			return;
		}
		setSelectedKeys([pkid]);
		setInfo({ pkid, type: moduleType, figureNumber });
		onSelect({ pkid, type: moduleType });
	}


	/**
	 * 知识弹窗宽度退拽
	 * @param _
	 * @param direction 方向
	 * @param elementRef 节点
	 * @param delta 移动像素
	 * @returns
	 */
	const resizeHandle = (_: any, direction: Direction, elementRef: HTMLElement, delta: NumberSize) => {
		if (direction !== 'right') {
			return;
		}
		const { width } = resizeDelta.current;
		const { width: mWidth } = delta;
		const relWidth = mWidth - width;
		resizeDelta.current = { width: mWidth, height: 0 };
		setModalWidth(Number(modalWidth) + relWidth);
	}


	return (
		<Modal
			visible={visible}
			className={generateClassName(['connect-knowledge-modal', className])}
			maskClosable={false}
			title="知识详情"
			destroyOnClose={true}
			width={modalWidth}
			footer={null}
			modalRender={(node: React.ReactNode) => (
				<Draggable
					handle=".connect-knowledge-modal .ant-modal-header"
					defaultPosition={{ x: (document.body.clientWidth - Number(width)) / 2, y: 100 }}
					bounds="body"
				>{node}
				</Draggable>
			)}
			{...restProps}
		>
			<div className="flex" style={{ height: 700 }}>
				<KnowledgeGroup
					className="h ptb8 ofa catalog"
					style={{ width: 280 }}
					defaultExpandAll={true}
					dataSource={dataSource}
					loading={loading}
					selectedKeys={selectedKeys}
					onSelect={select}
					onLoad={(treeData: any[]) => autoSelectFirstNode(treeData)}
				/>
				<Spin className="custom-fixed-loading-wrap" spinning={loading} />
				<Resizable
					className="pr ofa flex1 ofxh"
					enable={{ right: true }}
					onResize={resizeHandle}
					onResizeStart={() => {
						resizeDelta.current = { width: 0, height: 0 };
					}}
					onResizeStop={() => {
						resizeDelta.current = { width: 0, height: 0 };
					}}
					minWidth={570}
					maxWidth={1500}
					defaultSize={{ width: 570, height: '100%' }}
					style={{ zIndex: 1 }}
				>
					<div className="pr flex1 ofh">
						<div className="h plr8 ofa">
							{
								info ? (
									<Section showAttachment={true} pkid={info.pkid} moduleType={info.type} options={info} />
								) : (
									<CustomEmpty text="暂无内容" />
								)
							}
						</div>
					</div>
				</Resizable>
			</div>
		</Modal>
	)
}


export default ConnectKnowledgeModal;
